import request from '@/utils/axios'
import qs from 'qs'
import { getToken } from '../utils/auth'

/**
 * 获取所有会员信息
 * @param {} params 
 * {}
 */
export function getMemberInfo(params){
    const param = { ...params, username: getToken('USERNAME')}
    let postData = qs.stringify(param)
    return request({
      url: '/api/manager/member/getMemberInfo',
      method: 'post',
      data:postData
    })
  }

  export function getAllMemberInfo(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/member/getAllMemberInfo',
      method: 'get',
      data:postData
    })
  }
  
  export function addMember(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/member/addMember',
      method: 'post',
      data:postData
    })
  }
  
  export function updateMember(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/member/editMember',
      method: 'post',
      data:postData
    })
  }
  
  export function deleteMember(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/member/deleteMemberByUserName',
      method: 'post',
      data:postData
    })
  }
  
  export function batchDeleteMember(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/member/batchDeleteMember',
      method: 'post',
      data:postData
    })
  }

  //获取会员回收站列表
  export function getMemberInfoRecycle(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/member/getMemberInfoRecycle',
      method: 'post',
      data:postData
    })
  }
  //恢复会员
  export function recoverMember(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/member/recoverMember',
      method: 'post',
      data:postData
    })
  }